// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"65":"newsDetail","424":"homePage","435":"sub","818":"auth"}[chunkId] + "." + {"65":"eff23e3f","424":"9b8e4e25","435":"cb86ebb6","818":"4841dad2"}[chunkId] + ".js";
};